import { useState } from 'react'

import {
  Input,
  Select,
  Stack,
  Text,
  Textarea,
  useToast,
} from '@chakra-ui/react'
import { useDispatch } from 'react-redux'

import {
  loadCaseworkInstance,
  transferCaseworkInstance,
} from '../../../../redux/features/caseworkSlice'
import { addLeadingZeroToDistrict } from '../../../../utils'
import { ConfirmActionDialog } from '../../../ui'

const TransferDialog = ({ case_num, ...props }) => {
  const dispatch = useDispatch()
  const toast = useToast()

  const [selectedDistrict, setSelectedDistrict] = useState('')
  const [transferReason, setTransferReason] = useState('')

  const handleConfirm = () => {
    if (!selectedDistrict || !transferReason) return

    dispatch(
      transferCaseworkInstance({
        values: {
          case_num,
          transfer_reason: transferReason,
          district_to: selectedDistrict,
        },
        callbackSuccess: () => {
          toast({
            title: `Succesfully transferred casework to district ${selectedDistrict}`,
            status: 'info',
          })
          dispatch(loadCaseworkInstance({ case_num }))
        },
        callbackFailure: () => {
          toast({
            title: `Something went wrong while transferring casework to district ${selectedDistrict}`,
            status: 'error',
          })
        },
      })
    )
    props.onClose()
  }

  const districts = Array.from({ length: 51 }, (_, i) => String(i + 1))

  return (
    <ConfirmActionDialog {...props} onConfirm={handleConfirm}>
      <Text as='b' fontSize='lg'>
        Transferring casework to another district...
      </Text>
      <Text>
        <b>Warning:</b> The constituent will be made visible to all districts.
      </Text>
      <Stack mt={2}>
        <Input
          as={Select}
          placeholder='District (Required)'
          value={selectedDistrict}
          onChange={e => setSelectedDistrict(e.target.value)}
        >
          {districts?.map((district, index) => (
            <option value={addLeadingZeroToDistrict(district)} key={index}>
              {district}
            </option>
          ))}
        </Input>

        <Textarea
          placeholder='Transfer reason (Required)'
          value={transferReason}
          onChange={e => setTransferReason(e.target.value)}
        />
      </Stack>
    </ConfirmActionDialog>
  )
}

export default TransferDialog
